import React from 'react';
import { Path } from 'react-native-svg';
import SVGIcon from './SVGIcon';
import withDefaultIconProps from './withDefaultIconProps';
const SortIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { d: "m8 20 2.887-5H5.113L8 20Zm8-16-2.887 5h5.774L16 4ZM8.5 15.5V4h-1v11.5h1Zm7-7V20h1V8.5h-1Z", fill: color })));
};
export default withDefaultIconProps(SortIcon);
